export const generateScopeString = (scope) => {
    // string cannot contain slashes as it will alter the scope
    const hasForwardSlashes = scope.indexOf('/') !== -1;
    if (hasForwardSlashes) {
        throw new Error('Forward slashes found. Do not pass slashes here, this function adds one for you.');
    }
    if (scope.length === 0) {
        throw new Error('Scope must contain some path. Empty string found after splitting by slashes.');
    }
    return `/${scope}`;
};
export const extractScopeFromScopeString = (scopeString) => {
    const hasForwardSlashAtStart = scopeString.at(0) === '/';
    if (!hasForwardSlashAtStart) {
        throw new Error('Scope string must start with a forward slash');
    }
    const scopeElements = scopeString.split('/');
    // Splitting a proper strings returns ['', 'scope']
    if (scopeElements.length > 2) {
        throw new Error('Mulitple scope elements found. Do not scope the SW more than one level');
    }
    // If the string passed is okay the array looks like ['','scope']
    const scope = scopeElements.at(1);
    if (!scope) {
        throw new Error('Scope must contain some path. No element found at index 1 after splitting the scope by forward slashes');
    }
    if (scope.length === 0) {
        throw new Error('Scope must contain some path. Empty string found after removing the leading forward slash');
    }
    return scope;
};
export const extractScopeFromUrlString = (urlString) => {
    const url = new URL(urlString);
    const { pathname } = url;
    const pathElements = pathname.split('/');
    /// NOTE: For the file preview implenetation this check was skipped along with a
    //  unit test, everything works as expected and this check might actually not be needed
    //  for our use cases
    //
    // If the string passed is okay the array looks like ['','scope']
    // if (pathElements.length > 2) {
    //     throw new Error(
    //         'Multiple path elements found. Do not scope the SW more than one level',
    //     );
    // }
    // If the string passed is okay the array looks like ['','scope']
    const scope = pathElements.at(1);
    if (!scope) {
        throw new Error('No scope found after splitting the path name');
    }
    if (scope.length === 0) {
        throw new Error('Scope must contain some path. Empty string found at element 0 after splitting the path name');
    }
    return scope;
};
